import { render, staticRenderFns } from "./RackGuardsInfo.vue?vue&type=template&id=20d6c583"
import script from "./RackGuardsInfo.vue?vue&type=script&lang=js"
export * from "./RackGuardsInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports